import { render, staticRenderFns } from "./EmarScheduledTreatmentEventsV1Properties.vue?vue&type=template&id=b850c346&"
import script from "./EmarScheduledTreatmentEventsV1Properties.vue?vue&type=script&lang=js&"
export * from "./EmarScheduledTreatmentEventsV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports